import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["arrow"];
import React from 'react';
import { cssControlSize, cssSpacing, mapPhysicalToLogicalDirections, overlay, overlayArrow, rootStyle } from "../../styles/index.mjs";
import { Overlay } from "../OverlayTrigger/Overlay.mjs";
import { physicalDirectionWarning } from "../../logging.mjs";
import styled from "../../styled-components.mjs";
var overlayWidth = function overlayWidth(props) {
  return props.$large ? '600px' : '296px';
};
export var StyledPopover = styled.div.withConfig({
  displayName: "Popover__StyledPopover",
  componentId: "sc-1iog353-0"
})(["", ";", ";", ";", ";padding-block:", ";padding-inline:", ";text-transform:initial;overflow-wrap:break-word;", " &{pointer-events:all;}"], function (props) {
  return overlay({
    maxWidth: props.$large ? '70vw' : overlayWidth(props),
    colorSet: props.$colorSet
  });
}, function (props) {
  return props.$arrow && overlayArrow(props.$arrow);
}, rootStyle(), function (props) {
  return props.$large && "inline-size: ".concat(overlayWidth(props));
}, cssSpacing('base', '16px'), function (props) {
  return props.$paddedBody ? "".concat(cssSpacing('looser', '20px'), " calc(").concat(cssSpacing('tighter', '16px'), " + ").concat(cssControlSize('base', '48px'), ")") : cssSpacing('looser', '20px');
}, Overlay);
export var Popover = /*#__PURE__*/React.forwardRef(function Popover(_ref, ref) {
  var arrow = _ref.arrow,
    props = _objectWithoutProperties(_ref, _excluded);
  if (arrow) {
    physicalDirectionWarning(arrow, 'Popover');
  }
  return /*#__PURE__*/React.createElement(StyledPopover, Object.assign({
    ref: ref,
    $arrow: mapPhysicalToLogicalDirections(arrow)
  }, props));
});